import { Controller } from "@hotwired/stimulus";

// メーター交換時距離のフォーム制御を行うStimulusコントローラー
export default class extends Controller {
  #onShow = () => {
    this.form.attr("disabled", false);
    this.button.classList.add("checked");
  };

  #onHide = () => {
    this.form.attr("disabled", true);
    this.button.classList.remove("checked");
  };

  connect() {
    this.button = document.getElementById("has_mileage_when_exchanged");
    this.area = $("#mileage_when_exchanged_area");
    this.form = $("#mileage_when_exchanged_form");
    this.area.on("show.bs.collapse", this.#onShow);
    this.area.on("hide.bs.collapse", this.#onHide);
  }

  disconnect() {
    if (this.area) {
      this.area.off("show.bs.collapse", this.#onShow);
      this.area.off("hide.bs.collapse", this.#onHide);
    }
  }
}
